// Photo filenames for Holiday Party 2005
const HOLIDAY_PARTY_2005_PHOTOS = [
  'x0503_51854857778_z.jpg',
  'x0507_51855097684_z.jpg',
  'x0508_51855430050_z.jpg',
  'x0509_51853810132_z.jpg',
  'x0512_51854853703_z.jpg',
  'x0513_51854772631_z.jpg',
  'x0515_51854853673_z.jpg',
  'x0516_51854772621_z.jpg',
  'x0520_51853810072_z.jpg',
  'x0522_51854853658_z.jpg',
  'x0525_51855097584_z.jpg',
];

export default HOLIDAY_PARTY_2005_PHOTOS;
